import React, { useState } from 'react';
import { apiUrl } from '../utils/api';

const Testimonials = () => {
  const [formData, setFormData] = useState({
    name: '',
    message: '',
    rating: 5,
  });
  const [successMessage, setSuccessMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(apiUrl('/api/testimonials'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      if (!response.ok) throw new Error('Failed to submit testimonial');
      setSuccessMessage('Thank you! Your testimonial has been submitted and will be visible once approved by the admin.');
      setFormData({ name: '', message: '', rating: 5 });
    } catch (error) {
      console.error('Error submitting testimonial:', error);
    }
  };

  return (
    <div className="font-sans">
      <div className="max-w-3xl mx-auto px-4 py-10">
        <h1 className="text-3xl font-bold mb-6 text-center">Write a Testimonial</h1>
        {successMessage && (
          <p className="text-center text-green-600 mb-4">{successMessage}</p>
        )}
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-gray-700 font-medium mb-2">Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg"
              required
            />
          </div>
          <div>
            <label className="block text-gray-700 font-medium mb-2">Testimonial</label>
            <textarea
              type="text"
              name="message" // Ensure this matches the key in formData
              value={formData.message}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg"
              rows="4"
              required
            ></textarea>
          </div>
          <div>
            <label className="block text-gray-700 font-medium mb-2">Rating</label>
            <select
              name="rating"
              value={formData.rating}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg"
              required
            >
              {[5, 4, 3, 2, 1].map((value) => (
                <option key={value} value={value}>
                  {value} Star{value > 1 && 's'}
                </option>
              ))}
            </select>
          </div>
          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700"
          >
            Submit Testimonial
          </button>
        </form>
      </div>
    </div>
  );
};

export default Testimonials;